module.exports = __webpack_public_path__ + "img/guo.98bd7823.png";